import { create } from 'zustand';

export interface AuthUser {
  id: number;
  login: string;
  roles: string[];
}

interface AuthState {
  token?: string;
  user?: AuthUser;
  setAuth: (token: string, user: AuthUser) => void;
  logout: () => void;
}

const TOKEN_KEY = 'sqlops_token';
const USER_KEY = 'sqlops_user';

function loadUser(): AuthUser | undefined {
  try {
    const raw = sessionStorage.getItem(USER_KEY);
    return raw ? (JSON.parse(raw) as AuthUser) : undefined;
  } catch {
    return undefined;
  }
}

export const useAuthStore = create<AuthState>((set) => ({
  token: sessionStorage.getItem(TOKEN_KEY) ?? undefined,
  user: loadUser(),

  setAuth: (token, user) => {
    sessionStorage.setItem(TOKEN_KEY, token);
    sessionStorage.setItem(USER_KEY, JSON.stringify(user));
    set({ token, user });
  },

  logout: () => {
    sessionStorage.removeItem(TOKEN_KEY);
    sessionStorage.removeItem(USER_KEY);
    set({ token: undefined, user: undefined });
  },
}));
